import { useI18n } from "@/i18n";
import { Globe } from "lucide-react";

export default function LanguageToggle({ className = "" }) {
  const { lang, changeLang } = useI18n();
  return (
    <div className={`inline-flex items-center rounded-full border border-white/10 bg-ink-800/60 p-0.5 ${className}`} data-testid="nav-language-selector">
      <Globe className="w-3.5 h-3.5 text-slate-500 ml-2 mr-1" />
      {["es", "en"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}`}
          onClick={() => changeLang(l)}
          className={`px-3 py-1 text-xs font-semibold rounded-full transition-colors ${
            lang === l ? "bg-gold text-ink-900" : "text-slate-400 hover:text-slate-200"
          }`}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
